import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

type BrandSize = 'sm' | 'md' | 'lg' | 'xl';

const sizeClass: Record<BrandSize, string> = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-10',
  xl: 'h-12',
};

export interface BrandProps {
  size?: BrandSize;
  className?: string;
  onClick?: () => void;
}

export const Brand: React.FC<BrandProps> = ({ size = 'md', className = '', onClick }) => {
  const location = useLocation();

  const handleClick = (e: React.MouseEvent) => {
    // If already on home, scroll to top instead of re-navigating
    if (location.pathname === '/') {
      e.preventDefault();
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch {
        window.scrollTo(0, 0);
      }
    }
    onClick?.();
  };

  const h = sizeClass[size];

  return (
    <NavLink to="/" aria-label="Go to Dashboard" className={`inline-flex items-center ${className}`} onClick={handleClick}>
      {/* Light theme logo with density-based srcset */}
      <img
        src="/brand/break-records-light.png"
        srcSet="/brand/break-records-light@0.1x.png 0.1x, /brand/break-records-light@0.25x.png 0.25x, /brand/break-records-light@0.5x.png 0.5x, /brand/break-records-light.png 1x, /brand/break-records-light@2x.png 2x, /brand/break-records-light@3x.png 3x"
        alt=""
        className={`${h} w-auto dark:hidden`}
      />
      {/* Dark theme logo with density-based srcset */}
      <img
        src="/brand/break-records-dark.png"
        srcSet="/brand/break-records-dark@0.1x.png 0.1x, /brand/break-records-dark@0.25x.png 0.25x, /brand/break-records-dark@0.5x.png 0.5x, /brand/break-records-dark.png 1x, /brand/break-records-dark@2x.png 2x, /brand/break-records-dark@3x.png 3x"
        alt=""
        className={`${h} w-auto hidden dark:block`}
      />
      <span className="sr-only">Break Records</span>
    </NavLink>
  );
};

export default Brand;
